import { configureStore } from "@reduxjs/toolkit";
import CRUDreducer from "./reducers/CRUDreducer";
import ModeReducer from "./reducers/ModeReducer";
import AnswerReducer from "./reducers/AnswerReducer";
import AnswerReducer2 from "./reducers/AnswerReducer2";
import RoundReducer from "./reducers/RoundReducer";
import UserReducer from "./reducers/UserReducer";
import PracticeDataReducer from "./reducers/PracticeDataReducer";
import ScoreReducer from "./reducers/ScoreReducer";
import videoReducer from "./reducers/videoReducer";

export default configureStore({
  reducer: {
    crudUser: CRUDreducer,
    Mode: ModeReducer,
    Answer: AnswerReducer,
    Answer2: AnswerReducer2,
    Round: RoundReducer,
    UserInfo: UserReducer,
    PracticeData: PracticeDataReducer,
    allScore: ScoreReducer,
    countDown: videoReducer,
  },
});
